import Modal from '@material-ui/core/Modal';
import { useState } from 'react';
function Overlay(){

  let year = (new Date()).getFullYear();
  return (
    <div class="text-selectable" style={{padding:30,  userSelect:'auto'}}>

      <h1 style={{borderBottom:'1px solid #ccc',paddingBottom:10}}>Citing Sciugo</h1>

      <div class="fair-margin-top">
        <b>All</b> figures must be cited with the credit:
        <div style={{userSelect:'auto'}} class="fair-margin"><i>Created with <a href="#">https://sciugo.com</a></i>.</div>
      </div>

      <div>
        You may include this in the figure caption, reference-list, or acknowledgements.
      </div>

      <div class="fair-margin-top">
        For journals, you can use the following information:
        <ul>
          <li><b>Title:</b> Sciugo: life-science figure creation and data processing</li>
          <li><b>URL:</b> <a href="#">https://sciugo.com/</a></li>

          <li><b>Date published:</b> October 20, 2023</li>

          <li><b>Date accessed:</b> {year}
          </li>

        </ul>
      </div>




    </div>
  )
}

const color = "#f0f0f0";
let menuButtonStyle = { fontSize:12,
    background:color,
    display:'flex',
    alignItems:'center',
    lineHeight:0.5,
  }

export default function CiteButton(){

  const [ open, setOpen ] = useState(false);

  return (
    <>

      <div onClick={() => setOpen(true)} 
      style={menuButtonStyle} 
      class={"small-padding dark-hoverable round-corners tiny-margin clickable"}
      >Cite</div>

    <Modal style={{
    width:'70%', left:'15%',
    height:'70%', top:'15%',
    border:'3px solid #eee',
    background:'white',
    borderRadius:4,
  }} 
    open={open} 
      onClose={() => setOpen(false)}>


    <div style={{background:'white', 
      borderRadius:4,
      height:'100%'}}>
      <Overlay/>
    </div>
  </Modal>
    </>
  )

  

  

}
